import { useMutation } from "@/compat/reactQuery";
import nonUserService from "../../services/nonUserService";

const useAddAnonymousIncident = () => 
    useMutation((incident) => nonUserService.addIncident(incident));

export default useAddAnonymousIncident; 
